var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 7.5C16.402 7.5 7 16.902 7 28.5C7 40.098 16.402 49.5 28 49.5C39.598 49.5 49 40.098 49 28.5C49 16.902 39.598 7.5 28 7.5ZM1 28.5C1 13.5883 13.0883 1.5 28 1.5C42.9117 1.5 55 13.5883 55 28.5C55 43.4117 42.9117 55.5 28 55.5C13.0883 55.5 1 43.4117 1 28.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1716 18.7275L28.7724 39.6718L23.8281 36.2726L38.2273 15.3284L43.1716 18.7275Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 33.5L52 33.5L52 39.5L4 39.5L4 33.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.7c432faff4a7facb2fceb495c6b9def3.svg";
export { ForwardRef as ReactComponent };